import React, { useEffect, useState } from 'react';
import PaymentNavbar from './Payment/comp/PaymentNavbar';
import Required from '../components/Required';
import { useGlobalContext } from '../Contexts/GlobalContext';
import axios from 'axios';
import { BASE_URL } from '../Utlils';
import Select from 'react-select';
const CIS_BASE_URL =
  process.env.REACT_APP_CIS_BASE_URL ||
  'https://cis.app.miratsapiservices.com/v2/cis';
const COUNTRY_FIELDS = 'capital,name,alpha2Code,alpha3Code,emoji';

const Onboarding = () => {
  const {
    currencies,
    user,
    setSnackbar,
    getOrganization,
    organization,
    taxIdTypes,
  } = useGlobalContext();
  const [activeTab, setActiveTab] = useState(0);
  const [inputData, setInputData] = useState({});
  const [disableButton, setDisableButton] = useState(false);
  const [addressDetails, setAddressDetails] = useState({});
  const renderOnboarding = () => {
    switch (activeTab) {
      case 0:
        return (
          <OrganizationDetails
            currencies={currencies}
            inputData={inputData}
            setInputData={setInputData}
            taxIdTypes={taxIdTypes}
          />
        );
      default:
        return (
          <AddressDetails
            addressDetails={addressDetails}
            setAddressDetails={setAddressDetails}
          />
        );
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableButton(true);
    try {
      if (activeTab == 0) {
        localStorage.setItem('organizationDetails', JSON.stringify(inputData));
        setActiveTab((prev) => prev + 1);
      } else {
        let orgData = JSON.parse(localStorage.getItem('organizationDetails'));
        let finalData = {
          addresses: { billingAddress: addressDetails },
          name: orgData?.name,
          finance: orgData?.finance,
          projectSettings: orgData?.projectSettings,
          id: user?.organizationId,
        };
        const isNewOrg = !organization?.id;
        if (organization?.id) {
          await axios.put(`${BASE_URL}/company/${organization?.id}`, finalData);
        } else {
          await axios.post(`${BASE_URL}/company`, finalData);
        }

        await axios.put(`${BASE_URL}/users?id=${user?._id}`, {
          organizationName: orgData?.name,
        });
        getOrganization(finalData?.id);
        setSnackbar({
          open: true,
          msg: isNewOrg
            ? 'Organization details saved. Check your email for redirect setup instructions and your secret key.'
            : 'Organization details updated successfully !',
          severity: 'success',
        });
        localStorage.removeItem('organizationDetails');
        window.location.href = window.location.origin;
      }
    } catch (error) {
      console.log('error in creating org data', error);
      setSnackbar({
        open: true,
        msg: 'Something went wrong !',
        severity: 'error',
      });
    } finally {
      setDisableButton(false);
    }
  };
  useEffect(() => {
    setInputData({
      ...organization,
      finance: {
        taxIDType: organization?.finance?.taxIDType || '',
        taxID: organization?.finance?.taxID || '',
        timeZone:
          organization?.finance?.timeZone ||
          Intl.DateTimeFormat().resolvedOptions().timeZone,
        currency: organization?.finance?.currency || 'USD',
      },
      projectSettings: {
        expectedDropOfRate: 10,
        expectedQuotaRate: 20,
        ...organization?.projectSettings,
      },
    });
    setAddressDetails((prev) => ({
      ...prev,
      ...organization?.addresses?.billingAddress,
    }));
  }, [Object.keys(organization)?.length]);
  // console.log("organization=>", organization);
  // console.log("inputData=>", inputData);
  // console.log("addressDetails=>", addressDetails);
  return (
    <>
      <PaymentNavbar />
      <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 py-8 px-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-xl border border-gray-200 rounded-xl p-6 md:p-8 w-full max-w-2xl"
        >
          {/* Header */}
          <header className="mb-6 pb-6 border-b border-gray-200">
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <h1 className="text-[#0226BE] text-[24px] font-[600] mb-2">
                  Set Up Your Organization
                </h1>
                <p className="text-gray-600 text-[14px]">
                  {activeTab == 0
                    ? 'Please provide your organization details to get started'
                    : 'Add your billing address information'}
                </p>
              </div>
            </div>
            {/* Progress Bar */}
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2 overflow-hidden">
                <div
                  className="bg-[#0226BE] h-full rounded-full transition-all duration-300"
                  style={{ width: `${((activeTab + 1) / 2) * 100}%` }}
                />
              </div>
              <span className="text-gray-600 text-[14px] font-[500] min-w-[60px] text-right">
                Step {activeTab + 1} of 2
              </span>
            </div>
          </header>

          {/* Form Content */}
          <main className="w-full overflow-y-auto containerScroll min-h-[400px] max-h-[60vh] mb-6">
            {renderOnboarding()}
          </main>

          {/* Footer */}
          <footer className="w-full flex items-center justify-between pt-4 border-t border-gray-200">
            {activeTab > 0 && (
              <button
                type="button"
                onClick={() => setActiveTab((prev) => prev - 1)}
                className="px-5 py-2.5 border-2 border-gray-300 rounded-md text-gray-700 text-[14px] font-[500] hover:bg-gray-50 transition-colors"
              >
                Back
              </button>
            )}
            <div className="flex-1" />
            <button
              type="submit"
              disabled={disableButton}
              className={`px-6 py-2.5 bg-[#0226BE] text-white rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors ${
                disableButton ? 'opacity-75 cursor-not-allowed' : ''
              }`}
            >
              {disableButton ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  {activeTab == 0 ? 'Processing...' : 'Submitting...'}
                </span>
              ) : activeTab == 0 ? (
                'Next'
              ) : (
                'Submit'
              )}
            </button>
          </footer>
        </form>
      </div>
    </>
  );
};
const OrganizationDetails = ({
  currencies,
  inputData,
  setInputData,
  taxIdTypes,
}) => {
  const handleFinanceChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      finance: { ...prev?.finance, [name]: value },
    }));
  };
  const handleProjectSettingChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      projectSettings: { ...prev?.projectSettings, [name]: value },
    }));
  };
  return (
    <div className="space-y-5">
      <div className="flex flex-col gap-2">
        <label
          htmlFor="organizationName"
          className="text-[#1a1a1a] text-[14px] font-[500]"
        >
          Organization Name <Required />
        </label>
        <input
          type="text"
          required
          name="organizationName"
          value={inputData?.name || ''}
          placeholder="Enter organization name"
          onChange={(e) => {
            setInputData((prev) => ({ ...prev, name: e.target.value }));
          }}
          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="timeZone"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Time Zone <Required />
          </label>
          <Select
            name="timeZone"
            id="timeZone"
            required
            value={
              inputData?.finance?.timeZone
                ? {
                    value: inputData.finance.timeZone,
                    label: inputData.finance.timeZone,
                  }
                : null
            }
            onChange={(selected) => {
              handleFinanceChange({
                target: {
                  name: 'timeZone',
                  value: selected?.value || '',
                },
              });
            }}
            options={
              Intl?.supportedValuesOf('timeZone')?.map((tz) => ({
                value: tz,
                label: tz,
              })) || []
            }
            placeholder="Search time zone..."
            isSearchable
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                borderWidth: '1px',
                boxShadow: state.isFocused
                  ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                  : 'none',
                borderRadius: '6px',
                minHeight: '48px',
                fontSize: '14px',
                '&:hover': {
                  borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                },
                transition: 'all 0.2s ease-in-out',
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#0226BE'
                  : state.isFocused
                    ? '#f6f9ff'
                    : '#fff',
                color: state.isSelected ? '#fff' : '#333',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '10px 12px',
              }),
              menu: (base) => ({
                ...base,
                borderRadius: '6px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
              }),
              menuList: (base) => ({
                ...base,
                padding: '4px',
                maxHeight: '250px',
              }),
              indicatorSeparator: () => ({
                display: 'none',
              }),
            }}
            noOptionsMessage={({ inputValue }) =>
              inputValue
                ? `No time zone found for "${inputValue}"`
                : 'No time zones available'
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="currency"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Currency <Required />
          </label>
          <Select
            name="currency"
            id="currency"
            required
            value={
              inputData?.finance?.currency
                ? currencies?.find(
                    (c) => c.value === inputData.finance.currency,
                  ) || {
                    value: inputData.finance.currency,
                    label: inputData.finance.currency,
                  }
                : { value: 'USD', label: 'USD - US Dollar' }
            }
            onChange={(selected) => {
              handleFinanceChange({
                target: {
                  name: 'currency',
                  value: selected?.value || 'USD',
                },
              });
            }}
            options={
              currencies?.map((c) => ({
                value: c.value,
                label: c.label,
              })) || []
            }
            placeholder="Search currency..."
            isSearchable
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                borderWidth: '1px',
                boxShadow: state.isFocused
                  ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                  : 'none',
                borderRadius: '6px',
                minHeight: '48px',
                fontSize: '14px',
                '&:hover': {
                  borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                },
                transition: 'all 0.2s ease-in-out',
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#0226BE'
                  : state.isFocused
                    ? '#f6f9ff'
                    : '#fff',
                color: state.isSelected ? '#fff' : '#333',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '10px 12px',
              }),
              menu: (base) => ({
                ...base,
                borderRadius: '6px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
              }),
              menuList: (base) => ({
                ...base,
                padding: '4px',
                maxHeight: '250px',
              }),
              indicatorSeparator: () => ({
                display: 'none',
              }),
            }}
            noOptionsMessage={({ inputValue }) =>
              inputValue
                ? `No currency found for "${inputValue}"`
                : 'No currencies available'
            }
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="taxIDType"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Tax ID Type <Required />
          </label>
          <Select
            name="taxIDType"
            id="taxIDType"
            required
            value={
              inputData?.finance?.taxIDType
                ? {
                    value: inputData.finance.taxIDType,
                    label: inputData.finance.taxIDType,
                  }
                : null
            }
            onChange={(selected) => {
              handleFinanceChange({
                target: {
                  name: 'taxIDType',
                  value: selected?.value || '',
                },
              });
            }}
            options={
              taxIdTypes?.map((type) => ({
                value: type,
                label: type,
              })) || []
            }
            placeholder="Search tax ID type..."
            isSearchable
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                borderWidth: '1px',
                boxShadow: state.isFocused
                  ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                  : 'none',
                borderRadius: '6px',
                minHeight: '48px',
                fontSize: '14px',
                backgroundColor: '#fff',
                '&:hover': {
                  borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                },
                transition: 'all 0.2s ease-in-out',
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#0226BE'
                  : state.isFocused
                    ? '#f6f9ff'
                    : '#fff',
                color: state.isSelected ? '#fff' : '#333',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '10px 12px',
              }),
              menu: (base) => ({
                ...base,
                borderRadius: '6px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
                border: '1px solid #e5e7eb',
              }),
              menuList: (base) => ({
                ...base,
                padding: '4px',
                maxHeight: '250px',
              }),
              indicatorSeparator: () => ({
                display: 'none',
              }),
            }}
            noOptionsMessage={({ inputValue }) =>
              inputValue
                ? `No tax ID type found for "${inputValue}"`
                : 'No tax ID types available'
            }
          />
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="taxID"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Tax ID <Required />
          </label>
          <input
            type="text"
            required
            name="taxID"
            value={inputData?.finance?.taxID || ''}
            onChange={handleFinanceChange}
            placeholder="Enter tax ID"
            className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400 bg-white"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="expectedDropOfRate"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Expected Drop of Rate (%) <Required />
          </label>
          <input
            type="number"
            placeholder="10"
            required
            name="expectedDropOfRate"
            value={inputData?.projectSettings?.expectedDropOfRate || ''}
            onChange={handleProjectSettingChange}
            className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="expectedQuotaRate"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Expected Quota Rate (%) <Required />
          </label>
          <input
            type="number"
            placeholder="20"
            required
            name="expectedQuotaRate"
            value={inputData?.projectSettings?.expectedQuotaRate || ''}
            onChange={handleProjectSettingChange}
            className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
          />
        </div>
      </div>
    </div>
  );
};
const AddressDetails = ({ addressDetails, setAddressDetails }) => {
  const getCountryCode = (country) =>
    country?.iso2 ||
    country?.alpha2Code ||
    country?.country_code ||
    country?.code ||
    '';
  const getCountryName = (country) =>
    country?.name || country?.country_name || country?.countryName || '';
  const getStateCode = (state) =>
    state?.stateCode ||
    state?.state_code ||
    state?.state_id ||
    state?.iso2 ||
    '';
  const getStateName = (state) => state?.name || state?.state_name || '';
  const getCityName = (city) => city?.city_name || city?.name || '';

  const [countryStateCity, setCountryStateCity] = useState({
    country: [],
    state: [],
    city: [],
    countryLoading: true,
    stateLoading: false,
    cityLoading: false,
  });
  function handleChange(e) {
    const { name, value } = e.target;
    setAddressDetails({ ...addressDetails, [name]: value });
  }
  async function getAllCountry(e) {
    try {
      const countryResponse = await fetch(
        `${CIS_BASE_URL}/countries?all=true&fields=${COUNTRY_FIELDS}&sort=name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
        },
      );
      const countryPayload = await countryResponse.json();
      const countryData = Array.isArray(countryPayload?.data)
        ? countryPayload.data
        : [];
      if (addressDetails?.countryCode) {
        getAllCountryStates(addressDetails?.countryCode);
      }
      if (addressDetails?.stateCode) {
        getAllStatesCities(addressDetails?.stateCode);
      }
      setCountryStateCity((prev) => ({
        ...prev,
        country: countryData,
        countryLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, countryLoading: false }));
    }
  }
  async function getAllCountryStates(country) {
    try {
      setCountryStateCity((prev) => ({ ...prev, stateLoading: true }));
      const statesResponse = await fetch(
        `${CIS_BASE_URL}/countries/${country}/states?all=true&sort=name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
        },
      );
      const statesPayload = await statesResponse.json();
      const statesData = Array.isArray(statesPayload?.data)
        ? statesPayload.data
        : [];
      setCountryStateCity((prev) => ({
        ...prev,
        state: statesData?.sort((a, b) => {
          const aName = getStateName(a);
          const bName = getStateName(b);
          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          return 0;
        }),
        stateLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, stateLoading: false }));
    }
  }
  async function getAllStatesCities(state) {
    try {
      setCountryStateCity((prev) => ({ ...prev, cityLoading: true }));
      const encodedStateIdentifier = encodeURIComponent(state || '');
      const citiesResponse = await fetch(
        `${CIS_BASE_URL}/states/${encodedStateIdentifier}/cities?all=true&sort=city_name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
        },
      );
      const citiesPayload = await citiesResponse.json();
      const citiesData = Array.isArray(citiesPayload?.data)
        ? citiesPayload.data
        : [];
      setCountryStateCity((prev) => ({
        ...prev,
        city: citiesData,
        cityLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setCountryStateCity((prev) => ({ ...prev, cityLoading: false }));
    }
  }
  useEffect(() => {
    getAllCountry();
  }, []);
  // console.log(countryStateCity);
  // console.log(addressDetails);
  return (
    <div className="space-y-5">
      <div className="flex flex-col gap-2">
        <label
          htmlFor="street1"
          className="text-[#1a1a1a] text-[14px] font-[500]"
        >
          Street 1 <Required />
        </label>
        <input
          type="text"
          required
          onChange={handleChange}
          value={addressDetails?.street1 || ''}
          name="street1"
          placeholder="Enter street address"
          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
        />
      </div>
      <div className="flex flex-col gap-2">
        <label
          htmlFor="street2"
          className="text-[#1a1a1a] text-[14px] font-[500]"
        >
          Street 2 (Optional)
        </label>
        <input
          type="text"
          name="street2"
          onChange={handleChange}
          value={addressDetails?.street2 || ''}
          placeholder="Enter additional address details"
          className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="Country"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Country <Required />
          </label>
          {countryStateCity?.countryLoading ? (
            <div className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] flex items-center text-gray-500 text-[14px] bg-gray-50">
              Loading Countries...
            </div>
          ) : (
            <Select
              name="country"
              id="Country"
              required
              value={
                addressDetails?.countryCode
                  ? {
                      value: addressDetails.countryCode,
                      label: countryStateCity?.country?.find(
                        (c) => getCountryCode(c) === addressDetails.countryCode,
                      )
                        ? getCountryName(
                            countryStateCity?.country?.find(
                              (c) =>
                                getCountryCode(c) ===
                                addressDetails.countryCode,
                            ),
                          )
                        : addressDetails.country,
                    }
                  : null
              }
              onChange={(selected) => {
                if (selected) {
                  setCountryStateCity((prev) => ({
                    ...prev,
                    city: [],
                    state: [],
                  }));
                  getAllCountryStates(selected.value);
                  setAddressDetails((prev) => ({
                    ...prev,
                    country: selected.label,
                    countryCode: selected.value,
                    state: '',
                    stateCode: '',
                    city: '',
                  }));
                }
              }}
              options={
                countryStateCity?.country?.map((d) => ({
                  value: getCountryCode(d),
                  label: getCountryName(d),
                })) || []
              }
              placeholder="Search country..."
              isSearchable
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                  borderWidth: '1px',
                  boxShadow: state.isFocused
                    ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                    : 'none',
                  borderRadius: '6px',
                  minHeight: '48px',
                  fontSize: '14px',
                  '&:hover': {
                    borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                  },
                  transition: 'all 0.2s ease-in-out',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? '#0226BE'
                    : state.isFocused
                      ? '#f6f9ff'
                      : '#fff',
                  color: state.isSelected ? '#fff' : '#333',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '10px 12px',
                }),
                menu: (base) => ({
                  ...base,
                  borderRadius: '6px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  zIndex: 9999,
                }),
                menuList: (base) => ({
                  ...base,
                  padding: '4px',
                  maxHeight: '250px',
                }),
                indicatorSeparator: () => ({
                  display: 'none',
                }),
              }}
              noOptionsMessage={({ inputValue }) =>
                inputValue
                  ? `No country found for "${inputValue}"`
                  : 'No countries available'
              }
            />
          )}
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="state"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            State <Required />
          </label>
          {countryStateCity?.stateLoading ? (
            <div className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] flex items-center text-gray-500 text-[14px] bg-gray-50">
              Loading States...
            </div>
          ) : (
            <Select
              name="state"
              id="state"
              required
              value={
                addressDetails?.stateCode
                  ? {
                      value: addressDetails.stateCode,
                      label: countryStateCity?.state?.find(
                        (s) => getStateCode(s) === addressDetails.stateCode,
                      )
                        ? getStateName(
                            countryStateCity?.state?.find(
                              (s) =>
                                getStateCode(s) === addressDetails.stateCode,
                            ),
                          )
                        : addressDetails.state,
                    }
                  : null
              }
              onChange={(selected) => {
                if (selected) {
                  getAllStatesCities(selected.value);
                  setAddressDetails((prev) => ({
                    ...prev,
                    state: selected.label,
                    stateCode: selected.value,
                    city: '',
                  }));
                }
              }}
              options={
                countryStateCity?.state?.map((d) => ({
                  value: getStateCode(d) || getStateName(d),
                  label: getStateName(d),
                })) || []
              }
              placeholder="Search state..."
              isSearchable
              isDisabled={!addressDetails?.countryCode}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                  borderWidth: '1px',
                  boxShadow: state.isFocused
                    ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                    : 'none',
                  borderRadius: '6px',
                  minHeight: '48px',
                  fontSize: '14px',
                  backgroundColor: state.isDisabled ? '#f3f4f6' : '#fff',
                  '&:hover': {
                    borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                  },
                  transition: 'all 0.2s ease-in-out',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? '#0226BE'
                    : state.isFocused
                      ? '#f6f9ff'
                      : '#fff',
                  color: state.isSelected ? '#fff' : '#333',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '10px 12px',
                }),
                menu: (base) => ({
                  ...base,
                  borderRadius: '6px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  zIndex: 9999,
                }),
                menuList: (base) => ({
                  ...base,
                  padding: '4px',
                  maxHeight: '250px',
                }),
                indicatorSeparator: () => ({
                  display: 'none',
                }),
              }}
              noOptionsMessage={({ inputValue }) =>
                inputValue
                  ? `No state found for "${inputValue}"`
                  : addressDetails?.countryCode
                    ? 'No states available'
                    : 'Select country first'
              }
            />
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="city"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            City <Required />
          </label>
          {countryStateCity?.cityLoading ? (
            <div className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] flex items-center text-gray-500 text-[14px] bg-gray-50">
              Loading Cities...
            </div>
          ) : (
            <Select
              name="city"
              id="city"
              required
              value={
                addressDetails?.city
                  ? {
                      value: addressDetails.city,
                      label: addressDetails.city,
                    }
                  : null
              }
              onChange={(selected) => {
                if (selected) {
                  setAddressDetails((prev) => ({
                    ...prev,
                    city: selected.label,
                  }));
                }
              }}
              options={
                countryStateCity?.city?.map((d) => ({
                  value: getCityName(d),
                  label: getCityName(d),
                })) || []
              }
              placeholder="Search city..."
              isSearchable
              isDisabled={!addressDetails?.stateCode}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#0226BE' : '#d1d5db',
                  borderWidth: '1px',
                  boxShadow: state.isFocused
                    ? '0 0 0 2px rgba(2, 38, 190, 0.1)'
                    : 'none',
                  borderRadius: '6px',
                  minHeight: '48px',
                  fontSize: '14px',
                  backgroundColor: state.isDisabled ? '#f3f4f6' : '#fff',
                  '&:hover': {
                    borderColor: state.isFocused ? '#0226BE' : '#9ca3af',
                  },
                  transition: 'all 0.2s ease-in-out',
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? '#0226BE'
                    : state.isFocused
                      ? '#f6f9ff'
                      : '#fff',
                  color: state.isSelected ? '#fff' : '#333',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '10px 12px',
                }),
                menu: (base) => ({
                  ...base,
                  borderRadius: '6px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  zIndex: 9999,
                }),
                menuList: (base) => ({
                  ...base,
                  padding: '4px',
                  maxHeight: '250px',
                }),
                indicatorSeparator: () => ({
                  display: 'none',
                }),
              }}
              noOptionsMessage={({ inputValue }) =>
                inputValue
                  ? `No city found for "${inputValue}"`
                  : addressDetails?.stateCode
                    ? 'No cities available'
                    : 'Select state first'
              }
            />
          )}
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor="zipCode"
            className="text-[#1a1a1a] text-[14px] font-[500]"
          >
            Zip Code <Required />
          </label>
          <input
            type="text"
            required
            name="zipCode"
            value={addressDetails?.zipCode || ''}
            onChange={handleChange}
            placeholder="Enter zip code"
            className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
          />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
